"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.userRequiredSignatory = userRequiredSignatory;
exports.signSignatoryForTerms = signSignatoryForTerms;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _session = require("../session");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _user3 = require("./user");

function getUserActiveTerm(_x, _x2) {
  return _getUserActiveTerm.apply(this, arguments);
}

function _getUserActiveTerm() {
  _getUserActiveTerm = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(lang, companyId) {
    var _companyId, _ref, _lang, _context;

    var base, url, response;
    return _regenerator.default.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!((_companyId = companyId) !== null && _companyId !== void 0)) {
              _context2.next = 4;
              break;
            }

            _context2.t0 = _companyId;
            _context2.next = 7;
            break;

          case 4:
            _context2.next = 6;
            return (0, _session.getCompanyId)();

          case 6:
            _context2.t0 = _context2.sent;

          case 7:
            companyId = _context2.t0;

            if (!((_lang = lang) !== null && _lang !== void 0)) {
              _context2.next = 12;
              break;
            }

            _context2.t2 = _lang;
            _context2.next = 15;
            break;

          case 12:
            _context2.next = 14;
            return (0, _user3.getCurrentUser)();

          case 14:
            _context2.t2 = _context2.sent.language;

          case 15:
            _context2.t3 = _ref = _context2.t2;
            _context2.t1 = _context2.t3 !== null;

            if (!_context2.t1) {
              _context2.next = 19;
              break;
            }

            _context2.t1 = _ref !== void 0;

          case 19:
            if (!_context2.t1) {
              _context2.next = 23;
              break;
            }

            _context2.t4 = _ref;
            _context2.next = 24;
            break;

          case 23:
            _context2.t4 = 'en-US';

          case 24:
            lang = _context2.t4;
            _context2.next = 27;
            return (0, _environment.getRoute)('ProfileServices');

          case 27:
            base = _context2.sent;
            url = (0, _concat.default)(_context = "".concat(base, "/v1/companies/")).call(_context, companyId, "/terms/active");
            _context2.next = 31;
            return fetch(url, {
              headers: (0, _utils.jsonHeaders)({
                'Accept-Language': lang
              })
            });

          case 31:
            response = _context2.sent;
            _context2.next = 34;
            return (0, _internals.http500Thrower)(response);

          case 34:
            response = _context2.sent;

            if (!(response.status === 404)) {
              _context2.next = 37;
              break;
            }

            return _context2.abrupt("return", _promise.default.resolve(undefined));

          case 37:
            return _context2.abrupt("return", response.json());

          case 38:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));
  return _getUserActiveTerm.apply(this, arguments);
}

function getUserSignatoryForTerm(_x3, _x4) {
  return _getUserSignatoryForTerm.apply(this, arguments);
}

function _getUserSignatoryForTerm() {
  _getUserSignatoryForTerm = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(termsId, user) {
    var _user, _context3, _context4, _context5, _user$language;

    var base, url, response;
    return _regenerator.default.wrap(function _callee2$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!((_user = user) !== null && _user !== void 0)) {
              _context6.next = 4;
              break;
            }

            _context6.t0 = _user;
            _context6.next = 7;
            break;

          case 4:
            _context6.next = 6;
            return (0, _user3.getCurrentUser)();

          case 6:
            _context6.t0 = _context6.sent;

          case 7:
            user = _context6.t0;
            _context6.next = 10;
            return (0, _environment.getRoute)('ProfileServices');

          case 10:
            base = _context6.sent;
            url = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "".concat(base, "/v1/companies/")).call(_context5, user.companyId, "/terms/")).call(_context4, termsId, "/signatories/")).call(_context3, user.blueID);
            _context6.next = 14;
            return fetch(url, {
              headers: (0, _utils.jsonHeaders)({
                'Accept-Language': (_user$language = user.language) !== null && _user$language !== void 0 ? _user$language : 'en-US'
              })
            });

          case 14:
            response = _context6.sent;
            _context6.next = 17;
            return (0, _internals.http500Thrower)(response);

          case 17:
            response = _context6.sent;

            if (!(response.status === 404)) {
              _context6.next = 20;
              break;
            }

            return _context6.abrupt("return", _promise.default.resolve(undefined));

          case 20:
            return _context6.abrupt("return", response.json());

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee2);
  }));
  return _getUserSignatoryForTerm.apply(this, arguments);
}

function userRequiredSignatory() {
  return _userRequiredSignatory.apply(this, arguments);
}

function _userRequiredSignatory() {
  _userRequiredSignatory = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var meta, user, terms, signatory;
    return _regenerator.default.wrap(function _callee3$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return (0, _session.getMeta)();

          case 2:
            meta = _context7.sent;

            if (!meta.EmulateePrismGuid) {
              _context7.next = 5;
              break;
            }

            return _context7.abrupt("return", {});

          case 5:
            _context7.next = 7;
            return (0, _user3.getCurrentUser)();

          case 7:
            user = _context7.sent;

            if (user) {
              _context7.next = 10;
              break;
            }

            return _context7.abrupt("return", {});

          case 10:
            _context7.next = 12;
            return getUserActiveTerm(user.language, user.companyId);

          case 12:
            terms = _context7.sent;

            if (terms) {
              _context7.next = 15;
              break;
            }

            return _context7.abrupt("return", {});

          case 15:
            _context7.next = 17;
            return getUserSignatoryForTerm(terms.id, user);

          case 17:
            signatory = _context7.sent;
            return _context7.abrupt("return", {
              terms: terms,
              signatory: signatory
            });

          case 19:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee3);
  }));
  return _userRequiredSignatory.apply(this, arguments);
}

function signSignatoryForTerms(_x5, _x6) {
  return _signSignatoryForTerms.apply(this, arguments);
}

function _signSignatoryForTerms() {
  _signSignatoryForTerms = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(termsId, user) {
    var _user2, _context8, _context9;

    var base, url, response;
    return _regenerator.default.wrap(function _callee4$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            if (!((_user2 = user) !== null && _user2 !== void 0)) {
              _context10.next = 4;
              break;
            }

            _context10.t0 = _user2;
            _context10.next = 7;
            break;

          case 4:
            _context10.next = 6;
            return (0, _user3.getCurrentUser)();

          case 6:
            _context10.t0 = _context10.sent;

          case 7:
            user = _context10.t0;
            _context10.next = 10;
            return (0, _environment.getRoute)('ProfileServices');

          case 10:
            base = _context10.sent;
            url = (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = "".concat(base, "/v1/companies/")).call(_context9, user.companyId, "/terms/")).call(_context8, termsId, "/signatories");
            _context10.next = 14;
            return fetch(url, {
              body: (0, _stringify.default)({
                termsId: termsId,
                bluid: user.blueID
              }),
              headers: (0, _utils.jsonHeaders)(),
              method: 'POST'
            });

          case 14:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 16:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee4);
  }));
  return _signSignatoryForTerms.apply(this, arguments);
}
